import { render, staticRenderFns } from "./AnswerBox.vue?vue&type=template&id=c1563c8c"
import script from "./AnswerBox.vue?vue&type=script&lang=js"
export * from "./AnswerBox.vue?vue&type=script&lang=js"
import style0 from "./AnswerBox.vue?vue&type=style&index=0&id=c1563c8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports